/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import { Link, Text } from '@zapier/design-system';
import {
  BASE_APP_URL,
  PARTNER_SOLUTIONS_BASE_DOC_URL,
} from 'app/developer-v3/constants';
import Module from './Module';

type Props = {
  appId: number;
  conversionRate: number;
  isBeta: boolean;
};

export function EmbedStatus({ appId, conversionRate, isBeta }: Props) {
  const areEmbedsEnabled = conversionRate > 0;
  const marginTop = '10px';
  return (
    <Module
      figure={
        <div css={{ marginTop }}>
          {areEmbedsEnabled ? (
            <Icon
              color="StatusSuccessStrongest"
              name="ratingThumbsUpFill"
              size={70}
            />
          ) : (
            <Icon color="StatusError" name="ratingThumbsDownFill" size={70} />
          )}
        </div>
      }
      help="Embed status is based on the conversion from users who clicked on Zap templates in Zapier embeds to users who signed up to Zapier."
      isBeta={isBeta}
      stats={{
        current: (
          <Text tag="div" type="ParagraphHeader4">
            <Link href={`${BASE_APP_URL}/app/${appId}/insights`}>
              {formatPercentage(conversionRate)}
            </Link>
          </Text>
        ),
        lines: '',
        title: 'Sign-up conversion in the past 90 days',
      }}
      title="Embed status"
    >
      {areEmbedsEnabled ? (
        <Text>
          Nice! Your embed conversion rate has increased. Boost conversion rate
          by using the{' '}
          <Link href={`${PARTNER_SOLUTIONS_BASE_DOC_URL}/workflow-api/intro`}>
            Workflow API
          </Link>
          .
        </Text>
      ) : (
        <Text type="Body1">
          No embed conversions have been detected. Bring thousands of
          integrations into your product using our{' '}
          <Link href={`${BASE_APP_URL}/app/${appId}/embed`}>
            out-of-the-box
          </Link>{' '}
          tools or design a{' '}
          <Link href={`${PARTNER_SOLUTIONS_BASE_DOC_URL}/workflow-api/intro`}>
            custom experience
          </Link>
          .
        </Text>
      )}
    </Module>
  );
}

function formatPercentage(value: number | undefined | null): string {
  if (value === undefined || value === null || !Number.isFinite(value)) {
    return '0%';
  }

  return `${value.toFixed(1)}%`;
}
